"use client";

import { TireDetail } from "@/@types/Tire";
import Image from "next/image";
import Link from "next/link";
import { useState } from "react";
import ProductTabButton from "../products/ProductTabButton";

type Props = {
  tireDetails: TireDetail;
};

export default function TireSpecsCard({ tireDetails }: Props) {
  const [activeTab, setActiveTab] = useState("especificaciones");

  const handleTabChange = (tab: string) => {
    setActiveTab(tab);
  };

  const handleAvailableTabs = [
    tireDetails.specs !== undefined && tireDetails.specs !== null
      ? "especificaciones"
      : null,
    "general",
    tireDetails.files.length > 0 ? "documentos" : null,
  ].filter(Boolean);

  const gridCols = `grid-cols-${handleAvailableTabs.length}`;

  return (
    <div className="bg-white">
      <div className="container">
        <div className="my-4 lg:mt-0 lg:pb-40 border-t pt-4">
          <div
            className={`flex flex-col sm:flex-row w-full border-gray01`}
          >
            {tireDetails.specs !== undefined && tireDetails.specs !== null && (
              <ProductTabButton
                label="ESPECIFICACIONES"
                tabKey="especificaciones"
                activeTab={activeTab}
                onClick={() => handleTabChange("especificaciones")}
              />
            )}
            <ProductTabButton
              label="INFORMACION GENERAL"
              tabKey="general"
              activeTab={activeTab}
              onClick={() => handleTabChange("general")}
            />

            {tireDetails.files.length > 0 && (
              <ProductTabButton
                label="FOLLETOS"
                tabKey="documentos"
                activeTab={activeTab}
                onClick={() => handleTabChange("documentos")}
              />
            )}
          </div>

          <div className="mt-4">
            {activeTab === "especificaciones" &&
              tireDetails.specs !== undefined &&
              tireDetails.specs !== null && (
                <div className="overflow-x-auto w-full">
                  <div
                    className="min-w-full flex items-left justify-start"
                    dangerouslySetInnerHTML={{ __html: tireDetails.specs }}
                  ></div>
                </div>
              )}

            {activeTab === "general" && (
              <div>
                <p>{tireDetails.description}</p>
              </div>
            )}

            {activeTab === "documentos" && tireDetails.files.length > 0 && (
              <div>
                <p className="flex w-full uppercase self-center gap-2 border-b pb-2 text-gray-400">
                  DOCUMENTOS
                </p>
                <ul className="grid grid-cols-2 gap-4 text-md text-gray-900">
                  {tireDetails.files.map((file, index) => (
                    <li key={index}>
                      <Link
                        href={file.file}
                        download={file.fileName}
                        className="flex items-center justify-between gap-2 border-b py-2 hover:text-gray-500 transition"
                      >
                        <span>{file.fileName}</span>
                        <Image
                          src="/images/icons/download-icon.svg"
                          alt="Descargar"
                          width={25}
                          height={25}
                        />
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
